import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
    AuctionLotsFetchedFailedAction,
    AuctionLotsFetchedSuccessfulAction,
    SelectedAuctionUIActions,
    SelectAuctionAction,
} from './selected-auction.actions';
import {
    AuctionCatalogsService as AuctionsService,
    GetLotsByAuctionId200Response,
} from '@viewbid/ts-angular-client';

@Injectable()
export class SelectedAuctionEffects {
    auctionSelected$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(SelectedAuctionUIActions.SelectAuctionAction),
            switchMap((action: SelectAuctionAction) => {
                return this.auctionService
                    .getLotsByAuctionId(
                        action.props.auctionId,
                        action.props.page,
                        action.props.size,
                        action.props.auctionLotsId,
                    )
                    .pipe(
                        map((result: GetLotsByAuctionId200Response) => {
                            return new AuctionLotsFetchedSuccessfulAction({
                                result: result,
                            });
                        }),
                        catchError((_error: Error) => {
                            return of(new AuctionLotsFetchedFailedAction());
                        }),
                    );
            }),
        );
    });

    constructor(
        private actions$: Actions,
        private auctionService: AuctionsService,
    ) {}
}
